import { messages } from './messages';
import { CompassScope } from './types';
import { componentResultRenderer } from './result-renderer';
const mapAggregatorResponseToSearchItem = response => ({
  title: response.title,
  id: response.id,
  meta: response.ownerId,
  url: response.url,
  icon: response.type,
  containerId: '' // no container
});
export const getSections = intl => [{
  id: CompassScope.Component,
  title: intl.formatMessage(messages.compass_components_section_heading),
  scope: CompassScope.Component,
  showResultCount: true,
  resultRenderer: componentResultRenderer,
  resultMapper: ({
    results
  }) => results.map(value => mapAggregatorResponseToSearchItem(value))
}];